import React from 'react';
import { extLocalStore } from 'util/localStorage';
import { updateApiBaseUrl } from 'util/Api/config';
import { CLOUD_ENV } from 'appConstants';

export const useUpdateApiPath = () => {
	React.useEffect(() => {
		const cloudEnvironment = extLocalStore.getItem(CLOUD_ENV);
		if (cloudEnvironment) {
			updateApiBaseUrl({ cloudEnvironment, cacheIt: false });
		}
	}, []);
};
